import styled from "styled-components";
import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, mixins, rgba } from "@similarweb/styles";

export const StyledText = styled.span`
    flex-grow: 1;
    text-align: center;
    ${mixins.setFont({
        $color: colorsPalettes.carbon["0"],
        $size: 16,
    })};
`;

export const StyledButtonWrap = styled.div<{ isDisabled: boolean }>`
    align-items: center;
    background-color: transparent;
    border: 1px solid ${rgba(colorsPalettes.carbon["25"], 0.4)};
    border-radius: 4px;
    box-sizing: border-box;
    cursor: ${({ isDisabled }) => (isDisabled ? "not-allowed" : "pointer")};
    display: flex;
    height: 40px;
    opacity: ${({ isDisabled }) => (isDisabled ? 0.7 : 1)};
    min-width: 80px;
    padding: 0 16px;

    & ${SWReactIcons} {
        display: flex;
        margin-left: 8px;

        & svg path {
            fill: ${colorsPalettes.carbon["0"]};
        }
    }

    &:hover {
        background-color: ${({ isDisabled }) => (isDisabled ? "transparent" : rgba(colorsPalettes.carbon["0"], 0.2))};
    }
`;
